module.exports = __webpack_public_path__ + "static/media/pinterest-widgets-logo.2fe476d1.png";